// extracted by mini-css-extract-plugin
export var activeTransporterBanner = "activeTransporterBanner__hwet";